import KeenSlider from 'keen-slider';
import functions from '../functions';

class Slider {
	constructor(selector, origOpts = {}) {
		
		this.selector = selector;
		this.$element = $(selector);
		this.$slides = this.$element.find('.keen-slider__slide');
		this.$pager = this.$element.siblings('.keen-slider__pager');
		this.$arrows = this.$element.siblings('.keen-slider__arrows');
		
		this.origOpts = origOpts;

		if ( this.origOpts.fade ) {
			this.origOpts.slides = this.$slides.length;
			this.$element.addClass('keen-slider__fade');
		}
		this.opts = Object.assign({}, origOpts);
		this._autoplay = {
			hoverPause: false,
			dragPause: false
		};
		this.opts.created = () => {
			this.opts.autoplay && this.registerAutoplay();
			this.opts.arrows && this.registerArrows();
			this.opts.pager && this.registerPager();
			this.origOpts.created && this.origOpts.created();
			this.$element.addClass('keen-slider__created');
			this.$pager.addClass('keen-slider__created');
		};
		this.opts.dragStart = () => {
			this._autoplay.dragPause = true;
			this._tryAutoplay();
			this.origOpts.dragStart && this.origOpts.dragStart();
		};
		this.opts.dragEnd = () => {
			this._autoplay.dragPause = false;
			this._tryAutoplay();
			this.origOpts.dragEnd && this.origOpts.dragEnd();
		};
		this.opts.slideChanged = () => {
			setTimeout(() => {
				let activeIndex = this.instance.track.details.rel || 0;
				this.$slides.each((index, slide) => {
					let $slide = $(slide);
					$slide.toggleClass('active', index == activeIndex);

					// toggle hide if first element active
					$slide.toggleClass('hide', (activeIndex == 0 || activeIndex == 1) && index + 1 == this.$slides.length);

					// auto ajax load prev & next slides if applicable
					if ( index == activeIndex ) {
						$slide.next().add($slide.prev()).each(function () {
							let $slide = $(this);
							let bg = $slide.attr('data-background-image');
							bg && $slide.css('background-image', `url("${bg}")`);
						});
					}
				});

				if (this.$arrows.length) {
					const $prev = this.$arrows.find('[data-dir="prev"]');
					const $next = this.$arrows.find('[data-dir="next"]');

					activeIndex == 0 && $prev.addClass('disabled') && $next.removeClass('disabled');
					activeIndex > 0 && $prev.removeClass('disabled');

					const $activeSlide = $(this.instance.slides[activeIndex]);

					if ($activeSlide.next().hasClass('fake-slide')) {
						$next.addClass('disabled');
					} else if (activeIndex == this.instance.slides.length - 1) {
						$next.addClass('disabled');
					} else if(this.instance.slides.length > activeIndex) {
						$next.removeClass('disabled');
					}
				}

				let prevSlideIndex = 0;
				let perView = this.opts.slides.perView;

				this.$pager.length && this.$pager.find('button').each((index, btn) => {
					let slideIndex = +$(btn).attr('data-slide');

					if(functions.isMobile() || this.opts.loop) {
						$(btn).toggleClass('active', index == activeIndex);
					} else {
						$(btn).toggleClass('active', activeIndex >= slideIndex && slideIndex >= prevSlideIndex);
						activeIndex > (prevSlideIndex + perView-1) && this.$pager.find('button[data-slide="' + prevSlideIndex + '"]').removeClass('active');
						$(btn).hasClass('active') && $(btn).is(':last-child') && this.$pager.find('button[data-slide="' + prevSlideIndex + '"]').removeClass('active');
					}
					prevSlideIndex = slideIndex;
				});
				this._tryAutoplay();
				this.origOpts.slideChanged && this.origOpts.slideChanged();
			});
		};
		this.instance = new KeenSlider(this.$element[0], this.opts);

		const $firstSlide = $(this.instance.slides[0]);
		$firstSlide.addClass('active');

		let activeIndex = this.instance.track.details.rel || 0;
		activeIndex == 0 && this.$arrows.find('[data-dir="prev"]').addClass('disabled');

	}
	registerArrows() {
		this.$arrows.removeClass('d-none');
		this.$arrows.on('click', '[data-dir]', e => {
			e.preventDefault();
			this.instance[e.currentTarget.getAttribute('data-dir')]();
		});
	}
	registerPager() {
		// loop: false
		if ( this.$pager.length ) {

			const perView = Math.round(this.opts.slides.perView);
			const slidesLength = this.$slides.length;

			let lastPageIndex = slidesLength - 1;

			if(! functions.isMobile() && slidesLength % perView !== 0) {

				// ostatak su kartice koje ostaju na zadnjem pageu
				// index od zadnjeg page-a je ukupno slajda - ostatak
				let rest = Math.round(slidesLength / perView);
				lastPageIndex = slidesLength >= perView * 2 ? slidesLength - rest : rest;

			}

			if(! functions.isMobile() && perView >= 2 && ! this.opts.loop) {
				let html = '';
				for (let i = 0; i < slidesLength; i++) {
					if(i == 0 || i % Math.round(perView) === 0 || i == lastPageIndex) {
						if(i <= lastPageIndex) {
							html += `<button type="button" data-slide="${i}" class="${ i == 0 ? 'active' : '' }"></button>`;
						}
					}
				}
				this.$pager.find('.keen-slider__pager-buttons').html(html);
			} else {

				this.$pager.find('.keen-slider__pager-buttons').html($.map(this.$slides, function (slide, i) {
					return `<button type="button" data-slide="${i}" class="${ i == 0 ? 'active' : '' }"></button>`;
				}).join(''));
			}

			this.$element.addClass('keen-slider__hasPager');

			this.$pager.on('click', '[data-slide]', e => {
				e.preventDefault();
				this.instance.moveToIdx(parseInt(e.currentTarget.getAttribute('data-slide')));
			});

		}
	}
	registerPager_old() {
		if ( this.$pager.length ) {
			this.$pager.find('.keen-slider__pager-buttons').html($.map(this.$slides, function (slide, i) {
				return `<button type="button" data-slide="${i}" class="${ i == 0 ? 'active' : '' }"></button>`;
			}).join(''));

			this.$element.addClass('keen-slider__hasPager');
			this.$pager.on('click', '[data-slide]', e => {
				e.preventDefault();
				this.instance.moveToIdx(parseInt(e.currentTarget.getAttribute('data-slide')));
			});
		}
	}
	registerAutoplay() {
		if ( this.opts.pauseOnHover ) {
			this.$element.on('mouseenter', () => {
				this._autoplay.hoverPause = true;
				this._tryAutoplay();
			});
			this.$element.on('mouseleave', () => {
				this._autoplay.hoverPause = false;
				this._tryAutoplay();
			});
		}
		this._tryAutoplay();
	}
	_tryAutoplay() {
		if ( this.opts.autoplay ) {
			clearTimeout(this._autoplay.timeout);
			this._autoplay.timeout = setTimeout(() => {
				if ( !(this._autoplay.dragPause || this._autoplay.hoverPause) ) {
					this.instance.next();
				}
			}, this.opts.autoplay);
		}
	}
}

export default Slider;